import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Applicant } from '@models/recruiting/applicant.model';

export class ArchivedColumn extends Column {
    title = 'applicant-tracker.applicants-table.status';
    property = 'isArchived';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
    filter = new CheckListFilter('is_archived', [
        { label: 'applicant-tracker.statuses.active', value: '0', initiallyActive: true },
        { label: 'applicant-tracker.statuses.archived', value: '1' },
    ]);

    getDisplayPropertyValue(object: Applicant): string | number | null {
        return object.isArchived ? 'applicant-tracker.statuses.archived' : 'applicant-tracker.statuses.active';
    }
}
